import PropTypes from 'prop-types';

import {
  isNodeEmpty,
  Placeholder,
  SUMMARY_DEFINITIONS,
} from '@xing-com/content-editor-plugin-helpers';

import { SUMMARY_TAG_NAME } from './constants';

const Summary = ({
  className,
  SUMMARY_TAG = SUMMARY_TAG_NAME,
  ...attributes
}) => {
  const RenderLeaf = ({
    children,
    element,
    attributes: elementAttributes,
  } = {}) => {
    if (element.type === SUMMARY_DEFINITIONS.type) {
      const { placeholder, ...restOfAttributes } = attributes;

      if (placeholder && isNodeEmpty(element)) {
        return (
          <SUMMARY_TAG
            {...restOfAttributes}
            {...elementAttributes}
            data-editor-plugin={SUMMARY_DEFINITIONS.type}
            className={className}
          >
            {Placeholder(children, className, placeholder)}
          </SUMMARY_TAG>
        );
      } else {
        return (
          <SUMMARY_TAG
            {...restOfAttributes}
            {...elementAttributes}
            data-editor-plugin={SUMMARY_DEFINITIONS.type}
            className={className}
          >
            {children}
          </SUMMARY_TAG>
        );
      }
    }
  };
  return RenderLeaf;
};

Summary.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  SUMMARY_TAG: PropTypes.node,
};

export { Summary };
